export const PASSWORD_RULES = [
  { id: "length", label: "At least 8 characters", test: (p: string) => p.length >= 8 },
  {
    id: "upper",
    label: "One uppercase letter (A–Z)",
    test: (p: string) => /[A-Z]/.test(p),
  },
  {
    id: "lower",
    label: "One lowercase letter (a–z)",
    test: (p: string) => /[a-z]/.test(p),
  },
  { id: "number", label: "One number (0–9)", test: (p: string) => /[0-9]/.test(p) },
  {
    id: "special",
    label: "One special character (!@#$…)",
    test: (p: string) => /[^A-Za-z0-9]/.test(p),
  },
] as const;

export function validatePassword(password: string): string | null {
  for (const rule of PASSWORD_RULES) {
    if (!rule.test(password)) {
      return `Password must include: ${rule.label.toLowerCase()}.`;
    }
  }
  return null;
}

export function passwordMeetsAllRules(password: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}
